import { CountryCode } from '~/enums';
import { capitalizeFirstLetter } from './formatters.helper';

const convertDataUriToBinary = (base64: string, fileType?: string) => {
  const raw = window.atob(base64);
  const rawLength = raw.length;
  const array = new Uint8Array(new ArrayBuffer(rawLength));

  for (let i = 0; i < rawLength; i += 1) {
    array[i] = raw.charCodeAt(i);
  }
  const mimeType = fileType === '.zip' ? 'application/zip' : 'application/pdf';
  const blob = new Blob([array.buffer], {
    type: mimeType,
  });

  return blob;
};

export const generatePdfHelper = (
  data: string,
  type: string,
  companyName?: string,
  fileType?: string
) => {
  const market = window.__QRED_MARKET__ || 'se';
  const today = new Date();
  const formattedDate = today.toLocaleDateString();
  const formattedType = capitalizeFirstLetter(type);
  const _companyName = ` - ${companyName}`;
  const fileName = `${formattedDate} - ${
    market === CountryCode.NL ? 'Qeld' : 'Qred'
  } ${formattedType}${companyName ? _companyName : ''}${fileType}`;

  const downloadLink = document.createElement('a');
  const pdf = convertDataUriToBinary(data, fileType);
  if (pdf) {
    const link = URL.createObjectURL(pdf);
    downloadLink.href = link;
    downloadLink.download = fileName;
    downloadLink.click();
    URL.revokeObjectURL(link);
  }
};
